export default __webpack_public_path__ + "static/media/disco-krubh.eddb66f6.png";